import React from 'react';

import styles from './Checkbox.module.scss';

const Checkbox = ({
  label,
  checked,
  onChange = () => {},
  className = '',
  includeLabel = false,
}) => {
  const handleChange = () => {
    onChange(!checked);
  };

  const handleLabelClick = () => {
    if (includeLabel) onChange(!checked);
  };

  return (
    <div className={`${styles.root} ${className}`}>
      <span className={`${styles.checkbox} ${checked ? styles.checked : ''}`}>
        <svg
          className={styles.check}
          onClick={handleChange}
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 145 135"
        >
          {checked && (
            <polyline
              className={`${styles.path} ${checked ? styles.check : styles.uncheck}`}
              fill="none"
              stroke="black"
              strokeWidth="8"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="100.2,40.2 51.5,88.8 29.8,67.5"
            />
          )}
        </svg>
      </span>
      {label && (
        // eslint-disable-next-line
        <label
          id="checkbox"
          className={`${styles.label} ${includeLabel ? styles.includeLabel : ''}`}
          onClick={handleLabelClick}
        >
          Jag försäkrar att lämnade uppgifter är korrekta, att jag godkänner Blipps användarvillkor
          och integritetspolicy.
        </label>
      )}
    </div>
  );
};

export default Checkbox;
